import React, { useState } from 'react';
import { authAdminUpdate } from "../../service/api";
import { Box, Tab, Tabs, AppBar, Typography } from "@material-ui/core";
import SimpleModal from '../ModalComponent/ModalComponent';
import PropTypes from 'prop-types';
import ExtractConfigComponent from '../ExtractConfigComponent/ExtractConfigComponent';
import AdminSettingComponent from '../AdminSettingComponent/AdminSettingComponent';
import EventSystemAdminComponent from '../EventSystemAdminComponent/EventSystemAdminComponent';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} pt={6}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const SystemAdminComponent = (props) => {
  const [value, setValue] = React.useState(0);
  const [openModal, setOpenModal] = useState(true);
  const modalOkHandle = async (e) => {
    if(e) {
      const data = await authAdminUpdate(e);
      console.log(data)
      if (data && data?.data === 'TRUE') {
        setOpenModal(false);
      } else {
        modalCancelHandle()
      }
    }
    
  }

  const modalCancelHandle = () => {
    props.history.push("/notAuthorized", {
      pageName: "notAuthorized",
    });
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {openModal ?
        <div style={{ marginTop: '50px' }}>
          <SimpleModal
                        show={openModal}
                        okButtonHandler={(e) => modalOkHandle(e)}
                        cancelButtonHandler={modalCancelHandle}
                        color="#CC0000"
                        size="7x"
                        displayText1="Enter the Admin authorization keyword."
                        textFieldPlaceHolderText="Admin authorization keyword..."
                        buttonText1="CANCEL"
                        buttonText2="OK">
                        error
                    </SimpleModal></div> :
        <div style={{ marginTop: '50px' }}>
          <AppBar position="inherit" className='topBarAdmin'>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" className='tabset'>
              <Tab label="System Admin Settings" {...a11yProps(0)}/>
              <Tab label="Extract Config" {...a11yProps(1)}/>
              <Tab label="Events" {...a11yProps(2)}/>
            </Tabs>
          </AppBar>
          <div className='topDiclaimer'><Typography>* Currently, there are no validations on the data being modified. Please update as in the existing format. Contact application team for assistance.</Typography></div>
          <TabPanel value={value} index={0}>
          <AdminSettingComponent />
          </TabPanel>
          <TabPanel value={value} index={1}>
                <ExtractConfigComponent />
          </TabPanel>
          <TabPanel value={value} index={2}>
                <EventSystemAdminComponent />
          </TabPanel>
        </div>
      }
    </>
  )
};

export default SystemAdminComponent;